"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./style.css");
const document_selector_1 = require("src/libs/document-selector");
const wait_on_1 = require("src/libs/wait-on");
const chart_1 = require("src/libs/chart");
const watchlist_1 = __importDefault(require("src/libs/watchlist-portfo/watchlist"));
const asset_position_1 = __importDefault(require("src/libs/asset-position"));
const calculator_1 = require("../../coins/libs/calculator");
const chart_presentation_1 = require("./chart-presentation");
const chart_interactions_1 = require("../../coins/coins-details/chart-interactions");
const chart_settings_1 = require("../../coins/coins-details/chart-settings");
const live_chart_1 = require("./live-chart");
const converterInputSelector = [
    '[data-currency-pdp] .arz-input-coin-value',
    '[data-currency-pdp] .arz-input-coin-usd',
    '[data-currency-pdp] .arz-input-coin-tomans',
].join(', ');
const initializedCurrencyImages = new WeakSet();
const pendingCurrencyImages = new Set();
let currencyImageObserver = null;
let currencyImageFallbackStarted = false;
function initializeConverter() {
    document_selector_1.doc.on('input', converterInputSelector, function () {
        const input = $(this);
        const calculator = input.closest('[data-static-currency-converter]');
        const value = arzDigital.englishNumber(input.val());
        clearTimeout(input.data('timeout'));
        const timeout = window.setTimeout(() => {
            let type = 'coin';
            if (input.hasClass('arz-input-coin-usd')) {
                type = 'usd';
            }
            else if (input.hasClass('arz-input-coin-tomans')) {
                type = 'tomans';
            }
            calculator.data('changedField', type);
            (0, calculator_1.setCalculatorValues)(calculator, { type, val: value }, true);
        }, 400);
        input.data('timeout', timeout);
    });
}
function removeCurrencyImage(image) {
    const carousel = image.closest('.fiat-image-carousel');
    image.remove();
    if (carousel && !carousel.querySelector('[data-currency-image]')) {
        carousel.remove();
    }
}
function loadCurrencyImage(image) {
    var _a;
    const source = (_a = image.getAttribute('data-src')) === null || _a === void 0 ? void 0 : _a.trim();
    if (!source) {
        return;
    }
    const preloader = new Image();
    preloader.onload = () => {
        image.src = preloader.src;
        image.removeAttribute('data-src');
    };
    preloader.onerror = () => {
        removeCurrencyImage(image);
    };
    preloader.src = source;
}
function currencyImageIsVisible(image) {
    const rect = image.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    return rect.top < viewportHeight
        && rect.bottom > 0
        && rect.left < viewportWidth
        && rect.right > 0;
}
function stopCurrencyImageFallback() {
    if (!currencyImageFallbackStarted || pendingCurrencyImages.size) {
        return;
    }
    currencyImageFallbackStarted = false;
    window.removeEventListener('load', checkPendingCurrencyImages);
    window.removeEventListener('scroll', checkPendingCurrencyImages);
    window.removeEventListener('wheel', checkPendingCurrencyImages);
    window.removeEventListener('resize', checkPendingCurrencyImages);
    window.removeEventListener('arz:lazyload', checkPendingCurrencyImages);
}
function checkPendingCurrencyImages() {
    pendingCurrencyImages.forEach((image) => {
        if (!currencyImageIsVisible(image)) {
            return;
        }
        pendingCurrencyImages.delete(image);
        loadCurrencyImage(image);
    });
    stopCurrencyImageFallback();
}
function startCurrencyImageFallback() {
    if (currencyImageFallbackStarted) {
        return;
    }
    currencyImageFallbackStarted = true;
    window.addEventListener('load', checkPendingCurrencyImages, { passive: true });
    window.addEventListener('scroll', checkPendingCurrencyImages, { passive: true });
    window.addEventListener('wheel', checkPendingCurrencyImages, { passive: true });
    window.addEventListener('resize', checkPendingCurrencyImages, { passive: true });
    window.addEventListener('arz:lazyload', checkPendingCurrencyImages);
}
function getCurrencyImageObserver() {
    const IntersectionObserverConstructor = window.IntersectionObserver;
    if (typeof IntersectionObserverConstructor !== 'function') {
        return null;
    }
    if (!currencyImageObserver) {
        currencyImageObserver = new IntersectionObserverConstructor((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }
                const image = entry.target;
                currencyImageObserver === null || currencyImageObserver === void 0 ? void 0 : currencyImageObserver.unobserve(image);
                pendingCurrencyImages.delete(image);
                loadCurrencyImage(image);
            });
        });
    }
    return currencyImageObserver;
}
function initializeCurrencyImages() {
    const observer = getCurrencyImageObserver();
    document.querySelectorAll('[data-currency-image]').forEach((image) => {
        var _a;
        if (initializedCurrencyImages.has(image)) {
            return;
        }
        const source = (_a = image.getAttribute('data-src')) === null || _a === void 0 ? void 0 : _a.trim();
        if (!source) {
            return;
        }
        initializedCurrencyImages.add(image);
        pendingCurrencyImages.add(image);
        image.classList.remove('arz-lazyload');
        if (observer) {
            observer.observe(image);
        }
    });
    if (!observer && pendingCurrencyImages.size) {
        startCurrencyImageFallback();
        checkPendingCurrencyImages();
    }
}
initializeCurrencyImages();
function restoreViewportScroll(scrollY) {
    const previousScrollBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, scrollY);
    document.documentElement.style.scrollBehavior = previousScrollBehavior;
}
function initializeCurrencyImageViewer() {
    const viewer = document.querySelector('[data-currency-image-viewer]');
    const viewerImage = viewer === null || viewer === void 0 ? void 0 : viewer.querySelector('[data-currency-image-viewer-image]');
    const closeButton = viewer === null || viewer === void 0 ? void 0 : viewer.querySelector('[data-currency-image-viewer-close]');
    if (!viewer || !viewerImage || !closeButton) {
        return;
    }
    document.body.appendChild(viewer);
    let trigger = null;
    let viewerScrollY = 0;
    const closeViewer = () => {
        viewer.hidden = true;
        document.documentElement.classList.remove('currency-image-viewer-open');
        document.body.classList.remove('currency-image-viewer-open');
        document.body.style.removeProperty('top');
        viewerImage.removeAttribute('src');
        trigger === null || trigger === void 0 ? void 0 : trigger.focus({ preventScroll: true });
        restoreViewportScroll(viewerScrollY);
        trigger = null;
    };
    const openViewer = (image) => {
        const source = image.getAttribute('data-full-source') || image.currentSrc || image.src;
        if (!source) {
            return;
        }
        trigger = image;
        viewerImage.src = source;
        viewerImage.alt = image.alt;
        viewerScrollY = window.scrollY;
        document.body.style.top = `-${viewerScrollY}px`;
        viewer.hidden = false;
        document.documentElement.classList.add('currency-image-viewer-open');
        document.body.classList.add('currency-image-viewer-open');
        closeButton.focus();
    };
    document.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }
        const image = target.closest('[data-currency-image]');
        if (image) {
            openViewer(image);
            return;
        }
        if (target.closest('[data-currency-image-viewer-close]') || target === viewer) {
            closeViewer();
        }
    });
    document.addEventListener('keydown', (event) => {
        if (viewer.hidden) {
            if ((event.key === 'Enter' || event.key === ' ') && event.target instanceof HTMLImageElement && event.target.matches('[data-currency-image]')) {
                event.preventDefault();
                openViewer(event.target);
            }
            return;
        }
        if (event.key === 'Escape') {
            closeViewer();
        }
    });
}
function initializeCurrencyEditorialDisclosure() {
    document.querySelectorAll('[data-currency-editorial]').forEach((copy) => {
        const body = copy.querySelector('[data-currency-editorial-content]');
        const button = copy.querySelector('[data-currency-editorial-toggle]');
        if (!body || !button) {
            return;
        }
        const configuredHeight = Number(body.dataset.collapsedHeight);
        const collapsedHeight = Number.isFinite(configuredHeight) && configuredHeight > 0 ? configuredHeight : 500;
        let expansionTimer = null;
        if (body.scrollHeight <= collapsedHeight) {
            body.classList.remove('is-collapsed');
            body.style.maxHeight = 'none';
            button.hidden = true;
            body.classList.remove('is-fade-bottom');
            return;
        }
        body.style.maxHeight = `${collapsedHeight}px`;
        button.addEventListener('click', () => {
            const isCollapsed = body.classList.contains('is-collapsed');
            if (expansionTimer !== null) {
                window.clearTimeout(expansionTimer);
                expansionTimer = null;
            }
            button.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false');
            button.textContent = isCollapsed ? 'نمایش کمتر' : 'نمایش کامل';
            body.classList.toggle('is-fade-bottom', !isCollapsed);
            if (isCollapsed) {
                body.classList.remove('is-collapsed');
                body.style.maxHeight = `${body.scrollHeight}px`;
                expansionTimer = window.setTimeout(() => {
                    if (!body.classList.contains('is-collapsed')) {
                        body.style.maxHeight = 'none';
                    }
                    expansionTimer = null;
                }, 350);
                return;
            }
            body.style.maxHeight = `${body.scrollHeight}px`;
            body.classList.add('is-collapsed');
            window.requestAnimationFrame(() => {
                body.style.maxHeight = `${collapsedHeight}px`;
            });
            const bodyTop = body.getBoundingClientRect().top;
            if (bodyTop < 0) {
                window.scrollTo({
                    top: window.scrollY + bodyTop - 120,
                    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                });
            }
        });
    });
}
function getBitycleMode(mode) {
    if (mode === 'light' || mode === 'dark') {
        return mode;
    }
    const themeWindow = window;
    const currentMode = themeWindow.getArzTheme ? themeWindow.getArzTheme() : 'light';
    return currentMode === 'dark' ? 'dark' : 'light';
}
function initializeBitycle() {
    const widget = document.getElementById('bitycle-ac-widget');
    if (!(widget === null || widget === void 0 ? void 0 : widget.dataset.bitycleSymbol) || !widget.dataset.calendarType) {
        return;
    }
    let initialized = false;
    const updateBitycleTheme = (event) => {
        var _a;
        const requestedMode = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.theme;
        if (requestedMode !== 'light' && requestedMode !== 'dark') {
            return;
        }
        const iframe = widget.querySelector('iframe');
        if (!(iframe === null || iframe === void 0 ? void 0 : iframe.src)) {
            return;
        }
        try {
            const iframeUrl = new URL(iframe.src);
            if (iframeUrl.searchParams.get('mode') === requestedMode) {
                return;
            }
            iframeUrl.searchParams.set('mode', requestedMode);
            iframe.src = iframeUrl.toString();
        }
        catch (_error) {
            // Leave the current widget untouched if its URL cannot be parsed.
        }
    };
    const loadBitycle = () => {
        if (initialized) {
            return;
        }
        initialized = true;
        const config = {
            id: 'bitycle-ac-widget',
            theme: 'arzdigital',
            type: 'ac',
            locale: 'en',
            mode: getBitycleMode(),
            style: 'tradingview',
            datafeed_type: 'general',
            symbol: widget.dataset.bitycleSymbol,
            source_priority: [],
            interval: '1D',
            // Restoring a saved layout also restores its canvas colors over the site's mode.
            disabled_features: ['show_exchange', 'load_last_chart'],
            enabled_features: ['override_theme'],
            calendar_type: widget.dataset.calendarType,
        };
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://widget.bitycle.com/static/script/v1/script.js';
        script.async = true;
        script.textContent = JSON.stringify(config);
        document.body.appendChild(script);
    };
    window.addEventListener('arz-theme-change', updateBitycleTheme);
    const IntersectionObserverConstructor = window.IntersectionObserver;
    if (typeof IntersectionObserverConstructor === 'function') {
        const observer = new IntersectionObserverConstructor((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) {
                return;
            }
            observer.disconnect();
            loadBitycle();
        }, { rootMargin: '100px 0px' });
        observer.observe(widget);
        return;
    }
    const checkPosition = () => {
        const rect = widget.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const isNearViewport = rect.top <= viewportHeight + 100 && rect.bottom >= -100;
        if (!isNearViewport) {
            return;
        }
        window.removeEventListener('scroll', checkPosition);
        window.removeEventListener('resize', checkPosition);
        loadBitycle();
    };
    window.addEventListener('scroll', checkPosition, { passive: true });
    window.addEventListener('resize', checkPosition, { passive: true });
    checkPosition();
}
document_selector_1.doc.ready(() => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    yield Promise.all([
        (0, wait_on_1.WaitOn)('arzConstants'),
        (0, wait_on_1.WaitOn)('coin_info'),
        (0, wait_on_1.WaitOn)('arzDigital'),
    ]);
    const root = document.querySelector('[data-currency-pdp]');
    (_a = root === null || root === void 0 ? void 0 : root.closest('.arz-coin-page-body')) === null || _a === void 0 ? void 0 : _a.classList.add('arz-currency-pdp');
    (0, watchlist_1.default)([$('.add-to-watchlist')]);
    (0, asset_position_1.default)();
    const mobile = document.body.classList.contains('mobile');
    const chartPresentation = (0, chart_presentation_1.getCurrencyChartPresentation)((_b = root === null || root === void 0 ? void 0 : root.dataset) === null || _b === void 0 ? void 0 : _b.defaultCurrency);
    const primaryChart = new chart_1.chart(mobile ? 'coin-page-data-chart-mb' : 'coin-page-data-chart', false, 'coindetails', mobile ? 310 : 370, Object.assign(Object.assign({ range: '1w', selected: 1 }, chartPresentation), { currency: (0, chart_settings_1.loadCoinChartCurrency)(chart_interactions_1.chartSettingsStorage, coin_info.slug, chartPresentation.currency === 'irt'), livePrice: chart_interactions_1.chartSettings.get().livePrice, logarithmic: chart_interactions_1.chartSettings.get().logarithmic }));
    const chartElement = document.getElementById(primaryChart.container);
    const liveChart = root ? (0, live_chart_1.initializeCurrencyLiveChart)(primaryChart, root, chart_interactions_1.chartSettings) : null;
    if (chartElement && root) {
        (0, chart_interactions_1.mountChartSettingsWhenReady)(chartElement, {
            currency: primaryChart.chartType === 'irt' ? 'irt' : 'usd',
            onCurrencyChange: currency => {
                (0, chart_settings_1.saveCoinChartCurrency)(chart_interactions_1.chartSettingsStorage, coin_info.slug, currency);
                primaryChart.setCurrency(currency);
            },
            onLivePriceChange: enabled => liveChart === null || liveChart === void 0 ? void 0 : liveChart.setEnabled(enabled),
            onLogarithmicChange: enabled => primaryChart.setLogarithmicEnabled(enabled),
        });
        (0, chart_interactions_1.startChartCommentOverlay)(chartElement);
    }
    if (!mobile && document.getElementById('coinPriceAndEqualityOfIrrChart')) {
        new chart_1.chart('coinPriceAndEqualityOfIrrChart', true, 'overview', 370, Object.assign({ range: '1w', selected: 1 }, chartPresentation));
    }
    initializeConverter();
    initializeCurrencyImages();
    initializeCurrencyImageViewer();
    initializeCurrencyEditorialDisclosure();
    initializeBitycle();
}));
